import { render, staticRenderFns } from "./UsesInfoModal.vue?vue&type=template&id=38cae43c&scoped=true&"
import script from "./UsesInfoModal.vue?vue&type=script&lang=js&"
export * from "./UsesInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./UsesInfoModal.vue?vue&type=style&index=0&id=38cae43c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cae43c",
  null
  
)

export default component.exports